const MS_PER_DAY = 1000 * 60 * 60 * 24;

/** Days beyond which the preloader skips expensive AGG queries. */
export const ENROLMENT_WINDOW_DAYS = 30;

/**
 * Compute full 24-hour periods elapsed since enrolment.
 * Returns 0 when the date string is absent (not enrolled yet).
 */
export function getDaysSinceEnrolment(enrolmentDateStr: string | null | undefined): number {
	if (!enrolmentDateStr) {
		return 0;
	}
	return Math.floor((Date.now() - new Date(enrolmentDateStr).getTime()) / MS_PER_DAY);
}

/**
 * Returns true when the experiment is still within its active window:
 * - Not yet enrolled (null/undefined) → false, the experiment should not activate
 * - Enrolled within windowDays → true
 * - Enrolled longer ago → false
 */
export function isWithinEnrolmentWindow(
	enrolmentDateStr: string | null | undefined,
	windowDays: number = ENROLMENT_WINDOW_DAYS,
): boolean {
	if (!enrolmentDateStr) {
		return false;
	}
	return getDaysSinceEnrolment(enrolmentDateStr) <= windowDays;
}
